import fetchHTTP from 'Utils/fetchHTTP';

const sendEmailVerification = ({ userId }) => fetchHTTP('/v1/protected/email_verification/send_email', {
  data: { user_id: userId },
  method: 'POST',
});

const verifyEmail = ({ token }) => fetchHTTP('/v1/public/email_verification/verify', {
  data: { token },
  method: 'POST',
});

export {
  sendEmailVerification,
  verifyEmail,
};
